import { FadeUp } from "./Reveal";
import { MANIFESTO } from "@/data";

export default function Manifesto() {
  return (
    <section id="manifesto" className="py-24 lg:py-40 bg-[#0A0A0A]" data-testid="manifesto">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <FadeUp className="mb-16 lg:mb-24 max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#FF4D00]" aria-hidden="true" />
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4D00]">The Manifesto</span>
          </div>
          <h2 className="font-display font-bold uppercase tracking-tighter text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.9]">
            How We<br />Build
          </h2>
        </FadeUp>

        <div className="border-t border-[#333]">
          {MANIFESTO.map((m, i) => (
            <FadeUp
              key={m.number}
              delay={i * 0.05}
              className="group grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 py-10 lg:py-14 border-b border-[#333] items-start hover:bg-[#111] transition-colors px-2 lg:px-6"
              data-testid={`manifesto-${m.number}`}
            >
              <div className="lg:col-span-2 font-display font-black text-6xl lg:text-8xl text-[#333] group-hover:text-[#FF4D00] transition-colors leading-none">
                {m.number}
              </div>
              <h3 className="lg:col-span-4 font-display font-bold uppercase tracking-tight text-white text-3xl lg:text-4xl">
                {m.title}
              </h3>
              <p className="lg:col-span-6 font-mono font-light text-[#A3A3A3] text-base leading-relaxed">
                {m.body}
              </p>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
